export default __webpack_public_path__ + "static/media/_IMG3869.5b383230.jpg";